import { FC } from 'react';
import { Button, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { IInsightsPageTab, IInsightsPage } from '../../../logic/api';

interface ITabbedMenuProps {
  currentPage?: IInsightsPage;
  currentTab?: IInsightsPageTab;
  onChange: (tab: IInsightsPageTab) => void;
}

export const TabbedMenu: FC<ITabbedMenuProps> = ({ currentPage, currentTab, onChange }) => {
  const { push } = useHistory();

  const handleChange = (tab: IInsightsPageTab) => {
    onChange(tab);
    push(`?tabId=${tab.id}`);
  };

  if (!currentPage || !currentPage.tabs.length) {
    return null;
  }

  return (
    <Box sx={{
      textAlign: 'center',
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #eee',
      padding: '12px',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
    }}>
      {currentPage.tabs.map((tab) => (
        <Box
          key={tab.id}
          sx={{
            display: 'inline-block',
          }}
        >
          <Button
            onClick={() => handleChange(tab)}
            sx={{
              whiteSpace: 'nowrap',
              paddingLeft: '20px',
              paddingRight: '20px',
              fontWeight: 'bold',
              color: currentTab?.id === tab.id ? 'red' : 'inherit'
            }}
          >
            {tab.tabTitle}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default TabbedMenu;
